import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { 
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  FormControl,
  Box,
  Typography
} from '@mui/material';
import MyButton from '../../../utils/MyButton';
import { postDuplicarProgMtosRango, getListaMtosClienteFiltrado, clearErrors } from '../../../redux/actions/dataactions';
import { FaArrowLeft, FaPlus, FaCopy, FaCheck, FaCheckCircle } from "react-icons/fa";
import './CronogramaMtoAuto.css';

export class CronogramaMtoDuplicarRango extends Component {
  constructor() {
    super();
    this.state = {
      fechaInicio: '',
      fechaFin: '',
      errors: {},
      aprobado: {},
      open: false
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) {
      newState.errors = props.UI.errors;
    }
    if (props.UI.aprobado) {
      newState.aprobado = props.UI.aprobado;
    }
    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpen = () => {
    this.setState({ open: true, errors: {}, aprobado: {} });
  };

  handleClose = () => {
    const { credentials } = this.props.user;

    let responsable = "Todos";
    if (credentials.tipouser === "Tecnico") {
      responsable = credentials.handle;
    }

    if (this.state.aprobado.mensaje) {
      this.setState({
        fechaInicio: '',
        fechaFin: '',
        open: false,
        errors: {},
        aprobado: {}
      });
      // La acción ya recarga la lista
    } else {
      this.setState({
        fechaInicio: '',
        fechaFin: '',
        open: false,
        errors: {},
        aprobado: {}
      });
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { credentials } = this.props.user;
    let responsable = "Todos";
    if (credentials.tipouser === "Tecnico") {
      responsable = credentials.handle;
    }

    const data = {
      fechaInicio: this.state.fechaInicio,
      fechaFin: this.state.fechaFin
    };

    this.props.postDuplicarProgMtosRango(data, this.props.clienteId, responsable);
  };

  render() {
    const { UI: { loading } } = this.props;
    const { errors } = this.state;
    
    return (
      <Fragment>
        <div className='div-card-link' onClick={this.handleOpen}>
          <div className="dashing-cardcontent">
            <div className="dashing-cardtext">
              <p className="dashing-text-card">
                Duplicar en Rango de Fechas
              </p>
            </div>
            <div className="dashing-cardicon" style={{ backgroundColor: '#ff9800' }}>
              <FaCopy color="#FFFFFF" className="dashing-icon" />
            </div>
          </div>
        </div>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          {this.state.aprobado.mensaje ? (
            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado'/>
              </div>
              <h2 className='text-aprobado'>{this.state.aprobado.mensaje || 'Programación Duplicada Exitosamente'}</h2>
            </div>
          ) : (
            <div>
              <DialogTitle>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                  Duplicar Programaciones por Rango
                </Typography>
              </DialogTitle>
              <DialogContent>
                <Box component="form" onSubmit={this.handleSubmit}>
                  <FormControl fullWidth margin="normal">
                    <Typography sx={{ color: '#0468BF', fontSize: '18px', fontWeight: 400, ml: 1, mb: 1 }}>
                      Fecha de Inicio (Rango a Duplicar)
                    </Typography>
                    <TextField
                      type="date"
                      name="fechaInicio"
                      id="fechaInicio"
                      label="Fecha de inicio"
                      value={this.state.fechaInicio}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.fechaInicio || errors.error}
                      error={Boolean(errors.fechaInicio || errors.error)}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: "2020-01-01", max: "2035-12-31" }}
                    />
                  </FormControl>

                  <FormControl fullWidth margin="normal">
                    <Typography sx={{ color: '#0468BF', fontSize: '18px', fontWeight: 400, ml: 1, mb: 1 }}>
                      Fecha de Fin (Rango a Duplicar)
                    </Typography>
                    <TextField
                      type="date"
                      name="fechaFin"
                      id="fechaFin"
                      label="Fecha de fin"
                      value={this.state.fechaFin}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.fechaFin}
                      error={Boolean(errors.fechaFin)}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: "2020-01-01", max: "2035-12-31" }}
                    />
                  </FormControl>
                </Box>
              </DialogContent>
            </div>
          )}

          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
            </MyButton>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              this.state.aprobado.mensaje ? (
                <MyButton tip="Continuar" onClick={this.handleClose}>
                  <FaCheckCircle color="#0cae1aff" className="icon-formulario" />
                </MyButton>
              ) : (
                <MyButton tip="Duplicar Cronogramas" onClick={this.handleSubmit}>
                  <FaPlus color="#03178C" className="icon-formulario" />
                </MyButton>
              )
            )}
          </DialogActions>
        </Dialog>
      </Fragment>
    )
  }
}

CronogramaMtoDuplicarRango.propTypes = {
  postDuplicarProgMtosRango: PropTypes.func.isRequired,
  getListaMtosClienteFiltrado: PropTypes.func.isRequired,
  clienteId: PropTypes.string.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
};

const mapActionsToProps = { postDuplicarProgMtosRango, getListaMtosClienteFiltrado, clearErrors };

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(CronogramaMtoDuplicarRango);
